import { useMutation } from "@grandvisionhq/graphql";
import { useIntl } from "@grandvisionhq/state";
import { useNewsletterSubmit } from "./use-newsletter-submit.js";
import { SUBSCRIBE_NEWSLETTER_OPT_IN } from "../../operations/mutations/operations/mutations/subscribe-newsletter-opt-in.js";
const useSubscribeNewsletterViaOptIn = () => {
  const { locale } = useIntl();
  const [subscribeNewsletter] = useMutation(SUBSCRIBE_NEWSLETTER_OPT_IN, {
    context: {
      forwardHeaders: {
        "Accept-Language": locale
      }
    },
    onError: (error) => {
      console.error(`Error occurred while executing the newsletter mutation: ${error}`);
    }
  });
  const { onSubmit } = useNewsletterSubmit(subscribeNewsletter);
  return {
    onSubmit
  };
};
export {
  useSubscribeNewsletterViaOptIn
};
//# sourceMappingURL=use-subscribe-newsletter-via-opt-in.js.map
